
import { toast } from "sonner";

export const useClipboardActions = (generatedEmail: string) => {
  const handleCopyToClipboard = () => {
    if (!generatedEmail.trim()) {
      toast.error("Nothing to copy");
      return;
    }
    
    navigator.clipboard.writeText(generatedEmail);
    toast.success("Email copied to clipboard");
  };

  const handleDownload = () => {
    if (!generatedEmail.trim()) {
      toast.error("Nothing to download");
      return;
    }
    
    const filename = `email-draft-${new Date().toISOString()}.txt`;
    const element = document.createElement("a");
    const file = new Blob([generatedEmail], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = filename;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    toast.success("Email downloaded");
  };

  return {
    handleCopyToClipboard,
    handleDownload
  };
};
